import { DSNCVideo } from 'shared-definitions/types'
import { ApiComponentVideo } from 'data-source/types.wp'

export function ncVideo(input: ApiComponentVideo): DSNCVideo {
  return {
    resource: 'nc-video',
    link: input.mp4,
  }
}
